<template>
    <b-modal v-if="!loading" id="user_form" ref="user_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New User' : 'Edit User' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="8">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? (delete errors.name) : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!('name' in errors)"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="4">
                    <b-form-group label="Gender" class="has-float-label">
                        <template v-slot:label>
                            <span>Gender <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateGender" v-model="selected.gender" :options="genders"
                                  :border-danger="'gender' in errors"/>

                        <b-form-invalid-feedback :state="!'gender' in errors"
                                                 v-text="'gender' in errors ? errors.gender[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group class="mb-4">
                        <b-form-file v-model="image" placeholder="Choose a picture..."/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Position" class="has-float-label">
                        <template v-slot:label>
                            <span>Position <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.position" :class="{'border-danger': 'position' in errors}"
                                      @input="'position' in errors ? (delete errors.position) : ''"
                                      autocomplete="off" placeholder="Position"/>

                        <b-form-invalid-feedback :state="!('position' in errors)"
                                                 v-text="'position' in errors ? errors.position[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Company" class="has-float-label">
                        <template v-slot:label>
                            <span>Company <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.company" :class="{'border-danger': 'company' in errors}"
                                      @input="'company' in errors ? (delete errors.company) : ''"
                                      autocomplete="off" placeholder="Company"/>

                        <b-form-invalid-feedback :state="!('company' in errors)"
                                                 v-text="'company' in errors ? errors.company[0] : ''"/>
                    </b-form-group>
                </b-colxx>

<!--                <b-colxx md="6">-->
<!--                    <b-form-group label="Employee ID" class="has-float-label">-->
<!--                        <template v-slot:label>-->
<!--                            <span>Employee ID <sup><code>*</code></sup></span>-->
<!--                        </template>-->
<!--                        <b-form-input type="text" v-model="form.employee_id" :class="{'border-danger': 'employee_id' in errors}"-->
<!--                                      @input="'employee_id' in errors ? (delete errors.employee_id) : ''"-->
<!--                                      autocomplete="off" placeholder="Employee ID"/>-->
<!--                        <b-form-invalid-feedback :state="!('employee_id' in errors)"-->
<!--                                                 v-text="'employee_id' in errors ? errors.employee_id[0] : ''"/>-->
<!--                    </b-form-group>-->
<!--                </b-colxx>-->
            </b-row>

<!--            <b-row>-->
<!--                <b-colxx md="12">-->
<!--                    <b-form-group label="Address" class="has-float-label">-->
<!--                        <template v-slot:label>-->
<!--                            <span>Address <sup><code>*</code></sup></span>-->
<!--                        </template>-->

<!--                        <b-form-input type="text" v-model="form.address" :class="{'border-danger': 'address' in errors}"-->
<!--                                      @input="'address' in errors ? delete errors.address : ''"-->
<!--                                      autocomplete="off" placeholder="Address"/>-->

<!--                        <b-form-invalid-feedback :state="!'address' in errors"-->
<!--                                                 v-text="'address' in errors ? errors.address[0] : ''"/>-->
<!--                    </b-form-group>-->
<!--                </b-colxx>-->
<!--            </b-row>-->

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Project" class="has-float-label">
                        <template v-slot:label>
                            <span>Project <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.project" :class="{'border-danger': 'project' in errors}"
                                      @input="'project' in errors ? (delete errors.project) : ''"
                                      autocomplete="off" placeholder="Project"/>
                        <b-form-invalid-feedback :state="!('project' in errors)"
                                                 v-text="'project' in errors ? errors.project[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Phone" class="has-float-label">
                        <template v-slot:label>
                            <span>Phone <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-mask="'(###) ###-####'" v-model="form.phone"
                                      :class="{'border-danger': 'phone' in errors}"
                                      @input="'phone' in errors ? delete errors.phone : ''"
                                      autocomplete="off" placeholder="(XXX) XXX-XXXX"/>

                        <b-form-invalid-feedback :state="!'phone' in errors"
                                                 v-text="'phone' in errors ? errors.phone[0] : ''"/>
                    </b-form-group>
                </b-colxx>

<!--                <b-colxx md="6">-->
<!--                    <b-form-group label="City" class="has-float-label">-->
<!--                        <template v-slot:label>-->
<!--                            <span>City <sup><code>*</code></sup></span>-->
<!--                        </template>-->

<!--                        <b-form-input type="text" v-model="form.city" :class="{'border-danger': 'city' in errors}"-->
<!--                                      @input="'city' in errors ? delete errors.city : ''"-->
<!--                                      autocomplete="off" placeholder="City"/>-->

<!--                        <b-form-invalid-feedback :state="!'city' in errors"-->
<!--                                                 v-text="'city' in errors ? errors.city[0] : ''"/>-->
<!--                    </b-form-group>-->
<!--                </b-colxx>-->
            </b-row>

<!--            <b-row>-->
<!--                <b-colxx md="6">-->
<!--                    <b-form-group label="State" class="has-float-label">-->
<!--                        <template v-slot:label>-->
<!--                            <span>State <sup><code>*</code></sup></span>-->
<!--                        </template>-->

<!--                        <v-select @input="updateState" v-model="selected.state" :options="states"-->
<!--                                  :border-danger="'state_id' in errors"/>-->

<!--                        <b-form-invalid-feedback :state="!('state_id' in errors)"-->
<!--                                                 v-text="'state_id' in errors ? errors.state_id[0] : ''"/>-->
<!--                    </b-form-group>-->
<!--                </b-colxx>-->

<!--                <b-colxx md="6">-->
<!--                    <b-form-group label="ZIP" class="has-float-label">-->
<!--                        <template v-slot:label>-->
<!--                            <span>ZIP <sup><code>*</code></sup></span>-->
<!--                        </template>-->

<!--                        <b-form-input type="text" v-mask="'#####'" :class="{'border-danger': 'zip' in errors}"-->
<!--                                      @input="'zip' in errors ? delete errors.zip : ''"-->
<!--                                      v-model="form.zip" placeholder="XXXXX" autocomplete="off"/>-->

<!--                        <b-form-invalid-feedback :state="!'zip' in errors"-->
<!--                                                 v-text="'zip' in errors ? errors.zip[0] : ''"/>-->
<!--                    </b-form-group>-->
<!--                </b-colxx>-->
<!--            </b-row>-->

            <b-row>
<!--                <b-colxx md="6">-->
<!--                    <b-form-group label="Fax" class="has-float-label">-->
<!--                        <b-form-input type="text" v-model="form.fax" autocomplete="off" placeholder="Fax"/>-->
<!--                    </b-form-group>-->
<!--                </b-colxx>-->
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Email" class="has-float-label">
                        <template v-slot:label>
                            <span>Email <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.email" :class="{'border-danger': 'email' in errors}"
                                      @input="'email' in errors ? delete errors.email : ''"
                                      autocomplete="off" placeholder="your@email.com"/>

                        <b-form-invalid-feedback :state="!'email' in errors"
                                                 v-text="'email' in errors ? errors.email[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row v-if="!this.edit">
                <b-colxx md="6">
                    <b-form-group label="Password" class="has-float-label">
                        <template v-slot:label>
                            <span>Password <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="password" v-model="form.password" :class="{'border-danger': 'password' in errors}"
                                      @input="'password' in errors ? (delete errors.password) : ''"
                                      autocomplete="off" placeholder="Password"/>

                        <b-form-invalid-feedback :state="!('password' in errors)"
                                                 v-text="'password' in errors ? errors.password[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Confirm Password" class="has-float-label">
                        <template v-slot:label>
                            <span>Confirm Password <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="password" v-model="form.confirm_password" :class="{'border-danger': 'confirm_password' in errors}"
                                      @input="'confirm_password' in errors ? (delete errors.confirm_password) : ''"
                                      autocomplete="off" placeholder="Confirm Password"/>

                        <b-form-invalid-feedback :state="!('confirm_password' in errors)"
                                                 v-text="'confirm_password' in errors ? errors.confirm_password[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

<!--            <b-row>-->
<!--                <b-colxx md="12" class="mb-4">-->
<!--                    <b-form-group label="Notes" class="has-float-label">-->
<!--                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>-->
<!--                    </b-form-group>-->
<!--                </b-colxx>-->
<!--            </b-row>-->
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('user_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitUser">Submit</state-button>

            <state-button v-else variant="primary" :click="updateUser">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import StateButton from "../../../../components/Common/StateButton";
import moment from "moment";

export default {
    name: "UserFormModal",

    components: {
        StateButton,
    },

    props: [
        'edit',
    ],

    data() {
        return {
            loading: true,
            image: null,
            genders: [
                {label: 'Male', value: 'Male'},
                {label: 'Female', value: 'Female'},
                {label: 'Other', value: 'Other'},
            ],
            selected: {
                gender: [],
                state: [],
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getUserForm',
            errors: 'getUserErrors',
            // states: 'getSelectStates',
        }),
    },

    watch: {
        form() {
            if (this.edit) {
                this.selected.gender = this.form.select_gender;
            }
        },
    },

    mounted() {
        // this.getFormData();
        this.loading = false;
    },

    methods: {
        resetForm() {
            this.$store.commit('setUserForm');

            this.selected = {
                gender: [],
                // state: [],
            };
        },

        updateGender(field) {
            if (field) {
                this.form.gender = field.value;
            } else {
                this.form.gender = '';
            }
            'gender' in this.errors ? delete this.errors.gender : '';
        },

        // updateState(field) {
        //     if (field) {
        //         this.form.state_id = field.state_id;
        //     } else {
        //         this.form.state_id = '';
        //     }
        //     'state_id' in this.errors ? delete this.errors.state_id : '';
        // },

        // async getFormData() {
        //     await this.$store.dispatch('fetchSelectStates');
        //
        //
        //     return this.loading = false;
        // },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        uploadFiles(user) {
            if (this.image) {
                let image = new FormData();
                image.append('image', this.image);

                axios.post('/api/hms/users/' + user.user_id + '/image', image)
                    .catch(error => {
                        console.log(error);
                    });
            }
        },

        submitUser() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitUser', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new user!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('user_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateUser() {
            let payload = {
                ...this.form,
                deleted_attachments: this.deleted_attachments,
            };

            return new Promise((success, fail) => {
                this.$store.dispatch('updateUser', payload)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the user!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('user_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
